import React from 'react';
export const PrivacyPolicy = () => {
  return <main className="w-full bg-white py-16" data-id="element-381">
      <div className="container mx-auto px-4" data-id="element-382">
        <h1 className="text-4xl font-bold mb-8 text-center" data-id="element-383">Privacy Policy</h1>
        <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-sm border border-gray-100" data-id="element-384">
          <p className="text-gray-500 mb-8 text-sm" data-id="element-385">
            Last updated: January 1, 2023
          </p>
          <section className="mb-10" data-id="element-386">
            <h2 className="text-2xl font-semibold mb-4" data-id="element-387">1. Introduction</h2>
            <p className="text-gray-700 mb-4" data-id="element-388">
              Binary Solutions 101010 ("we," "our," or "us") is committed to
              protecting your privacy. This Privacy Policy explains how your
              personal information is collected, used, and disclosed by Binary
              Solutions 101010.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-389">
              This Privacy Policy applies to our website, and its associated
              subdomains (collectively, our "Service") alongside our
              application, Binary Solutions 101010. By accessing or using our
              Service, you signify that you have read, understood, and agree to
              our collection, storage, use, and disclosure of your personal
              information as described in this Privacy Policy and our Terms of
              Service.
            </p>
          </section>
          <section className="mb-10" data-id="element-390">
            <h2 className="text-2xl font-semibold mb-4" data-id="element-391">
              2. Information We Collect
            </h2>
            <p className="text-gray-700 mb-4" data-id="element-392">
              We collect information from you when you visit our website,
              register on our site, place an order, subscribe to our newsletter,
              respond to a survey, fill out a form, or use our application.
            </p>
            <h3 className="text-xl font-semibold mb-3 mt-6" data-id="element-393">
              2.1 Personal Data
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-394">
              While using our Service, we may ask you to provide us with certain
              personally identifiable information that can be used to contact or
              identify you ("Personal Data"). Personally identifiable
              information may include, but is not limited to:
            </p>
            <ul className="list-disc pl-8 mb-4 text-gray-700" data-id="element-395">
              <li data-id="element-396">Email address</li>
              <li data-id="element-397">First name and last name</li>
              <li data-id="element-398">Phone number</li>
              <li data-id="element-399">Address, State, Province, ZIP/Postal code, City</li>
              <li data-id="element-400">Cookies and Usage Data</li>
            </ul>
          </section>
          <section className="mb-10" data-id="element-401">
            <h2 className="text-2xl font-semibold mb-4" data-id="element-402">
              3. How We Use Your Information
            </h2>
            <p className="text-gray-700 mb-4" data-id="element-403">
              We use the information we collect in various ways, including to:
            </p>
            <ul className="list-disc pl-8 mb-4 text-gray-700" data-id="element-404">
              <li data-id="element-405">Provide, operate, and maintain our website and services</li>
              <li data-id="element-406">Improve, personalize, and expand our website and services</li>
              <li data-id="element-407">
                Understand and analyze how you use our website and services
              </li>
              <li data-id="element-408">
                Develop new products, services, features, and functionality
              </li>
              <li data-id="element-409">
                Communicate with you, either directly or through one of our
                partners, to provide you with updates and other information
                relating to the website and for marketing and promotional
                purposes
              </li>
              <li data-id="element-410">Send you emails</li>
              <li data-id="element-411">Find and prevent fraud</li>
            </ul>
          </section>
          <section className="mb-10" data-id="element-412">
            <h2 className="text-2xl font-semibold mb-4" data-id="element-413">4. Data Retention</h2>
            <p className="text-gray-700 mb-4" data-id="element-414">
              We will retain your Personal Data only for as long as is necessary
              for the purposes set out in this Privacy Policy. We will retain
              and use your Personal Data to the extent necessary to comply with
              our legal obligations (for example, if we are required to retain
              your data to comply with applicable laws), resolve disputes, and
              enforce our legal agreements and policies.
            </p>
          </section>
          <section className="mb-10" data-id="element-415">
            <h2 className="text-2xl font-semibold mb-4" data-id="element-416">5. Data Security</h2>
            <p className="text-gray-700 mb-4" data-id="element-417">
              The security of your data is important to us, but remember that no
              method of transmission over the Internet, or method of electronic
              storage is 100% secure. While we strive to use commercially
              acceptable means to protect your Personal Data, we cannot
              guarantee its absolute security.
            </p>
          </section>
          <section className="mb-10" data-id="element-418">
            <h2 className="text-2xl font-semibold mb-4" data-id="element-419">6. Your Rights</h2>
            <p className="text-gray-700 mb-4" data-id="element-420">
              If you are a resident of the European Economic Area (EEA), you
              have certain data protection rights. Binary Solutions 101010 aims
              to take reasonable steps to allow you to correct, amend, delete,
              or limit the use of your Personal Data.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-421">
              If you wish to be informed what Personal Data we hold about you
              and if you want it to be removed from our systems, please contact
              us.
            </p>
          </section>
          <section className="mb-10" data-id="element-422">
            <h2 className="text-2xl font-semibold mb-4" data-id="element-423">
              7. Changes to This Privacy Policy
            </h2>
            <p className="text-gray-700 mb-4" data-id="element-424">
              We may update our Privacy Policy from time to time. We will notify
              you of any changes by posting the new Privacy Policy on this page.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-425">
              We will let you know via email and/or a prominent notice on our
              Service, prior to the change becoming effective and update the
              "effective date" at the top of this Privacy Policy.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-426">
              You are advised to review this Privacy Policy periodically for any
              changes. Changes to this Privacy Policy are effective when they
              are posted on this page.
            </p>
          </section>
          <section data-id="element-427">
            <h2 className="text-2xl font-semibold mb-4" data-id="element-428">8. Contact Us</h2>
            <p className="text-gray-700 mb-4" data-id="element-429">
              If you have any questions about this Privacy Policy, please
              contact us:
            </p>
            <ul className="list-disc pl-8 mb-4 text-gray-700" data-id="element-430">
              <li data-id="element-431">Email: am@binary-solutions.co.za</li>
              <li data-id="element-432">Phone: + 27 677 834 937</li>
              <li data-id="element-433">
                Address: 296 francis baard street office 0314, pretoria cbd,
                gauteng, 0002
              </li>
            </ul>
          </section>
        </div>
      </div>
    </main>;
};